import React from 'react'
import { BackButton } from '@/components/ui/BackButton'

export function PageTopNav({
  pageName,
  rightItem
}: {
  pageName: string;
  rightItem?: React.ReactNode;
}) {
  return (
    <div className="flex justify-between items-center mb-6">
      <BackButton />
      <h1 className="text-xl md:text-2xl text-center sm:text-left font-bold">
        {pageName}
      </h1>
      {rightItem ? rightItem : <div className="size-8"></div>}
    </div>
  )
}
